import { GeschaedigtesGeraet } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_GESCHAEDIGTE_GERAETE_EINFACH = 'GESCHAEDIGTE-GERAETE-EINFACH';

export interface GeschaedigteGeraeteEinfachModelConfig extends DynamicFormValueControlModelConfig<GeschaedigtesGeraet[]> {
}

export class GeschaedigteGeraeteEinfachModel extends DynamicFormValueControlModel<GeschaedigtesGeraet[]> {
  @serializable() readonly type: string = TYPE_GESCHAEDIGTE_GERAETE_EINFACH;

  constructor(config: GeschaedigteGeraeteEinfachModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
